import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { PrizesService } from '../prizes.service';

@Component({
  selector: 'app-add-prize',
  templateUrl: './add-prize.component.html',
  styleUrls: ['./add-prize.component.scss']
})
export class AddPrizeComponent implements OnInit {

  prizeForm = new FormGroup ( {
    title: new FormControl ('', [Validators.required]),
    subtitle: new FormControl (''),
    description: new FormControl ('', [Validators.required]),
    image: new FormControl (''),
    link: new FormControl (''),
  })

  constructor(
    private prizesService: PrizesService,
    private toastyService: ToastyService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.prizeForm.controls;
  }

  setImageUrl(event): void {
    this.f.image.setValue(event ? event.filename : null);
  }

  addPrize(): void {
    this.prizesService.addPrize(this.prizeForm.value)
    .subscribe((res: {data: any}) => {
      this.toastyService.success({
        title: 'Prize salvato',
        msg: 'Il tuo prize "<b>' + res.data.title + '</b>" è stato salvato correttamente.'
      });
      this.router.navigate(['/prizes']);
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
